import logo1 from "../../assets/img/ple/wrestlemania/logos/1.png";
import logo2 from "../../assets/img/ple/wrestlemania/logos/2.png";
import logo3 from "../../assets/img/ple/wrestlemania/logos/3.png";
import logo4 from "../../assets/img/ple/wrestlemania/logos/4.png";
import logo5 from "../../assets/img/ple/wrestlemania/logos/5.png";
import logo6 from "../../assets/img/ple/wrestlemania/logos/6.png";
import logo7 from "../../assets/img/ple/wrestlemania/logos/7.png";
import logo8 from "../../assets/img/ple/wrestlemania/logos/8.png";
import logo9 from "../../assets/img/ple/wrestlemania/logos/9.png";
import logo10 from "../../assets/img/ple/wrestlemania/logos/10.png";
import logo11 from "../../assets/img/ple/wrestlemania/logos/11.png";
import logo12 from "../../assets/img/ple/wrestlemania/logos/12.png";
import logo13 from "../../assets/img/ple/wrestlemania/logos/13.png";
import logo14 from "../../assets/img/ple/wrestlemania/logos/14.png";
import logo15 from "../../assets/img/ple/wrestlemania/logos/15.png";
import logo16 from "../../assets/img/ple/wrestlemania/logos/16.png";
import logo17 from "../../assets/img/ple/wrestlemania/logos/17.png";
import logo18 from "../../assets/img/ple/wrestlemania/logos/18.png";
import logo19 from "../../assets/img/ple/wrestlemania/logos/19.png";
import logo20 from "../../assets/img/ple/wrestlemania/logos/20.png";
import logo21 from "../../assets/img/ple/wrestlemania/logos/21.png";
import logo22 from "../../assets/img/ple/wrestlemania/logos/22.png";
import logo23 from "../../assets/img/ple/wrestlemania/logos/23.png";
import logo24 from "../../assets/img/ple/wrestlemania/logos/24.png";
import logo25 from "../../assets/img/ple/wrestlemania/logos/25.png";
import logo26 from "../../assets/img/ple/wrestlemania/logos/26.png";
import logo27 from "../../assets/img/ple/wrestlemania/logos/27.png";
import logo28 from "../../assets/img/ple/wrestlemania/logos/28.png";
import logo29 from "../../assets/img/ple/wrestlemania/logos/29.png";
import logo30 from "../../assets/img/ple/wrestlemania/logos/30.png";
import logo31 from "../../assets/img/ple/wrestlemania/logos/31.png";
import logo32 from "../../assets/img/ple/wrestlemania/logos/32.png";
import logo33 from "../../assets/img/ple/wrestlemania/logos/33.png";
import logo34 from "../../assets/img/ple/wrestlemania/logos/34.png";
import logo35 from "../../assets/img/ple/wrestlemania/logos/35.png";
import logo36 from "../../assets/img/ple/wrestlemania/logos/36.png";
import logo37 from "../../assets/img/ple/wrestlemania/logos/37.png";
import logo38 from "../../assets/img/ple/wrestlemania/logos/38.png";
import logo39 from "../../assets/img/ple/wrestlemania/logos/39.png";
import logo40 from "../../assets/img/ple/wrestlemania/logos/40.png";
import logo41 from "../../assets/img/ple/wrestlemania/logos/41.png";
import logo42 from "../../assets/img/ple/wrestlemania/logos/42.png";

export const wrestlemaniaDetail = {
  id: "wrestlemania",
  title: "WrestleMania",
  subtitle: "Explore event editions in a dedicated event view.",
  tabs: [
    {
      id: "logos",
      label: "Editions",
      variant: "wrestlemania",
      items: [
        {
          id: "wm-logo-1",
          title: "WrestleMania",
          description: "The Greatest Wrestling Event of All Time! 1985",
          imgUrl: logo1,
        },
        {
          id: "wm-logo-2",
          title: "WrestleMania 2",
          description: "The Premier Sporting Event of the Year! 1986",
          imgUrl: logo2,
        },
        {
          id: "wm-logo-3",
          title: "WrestleMania III",
          description: "Bigger! Better! Badder! 1987",
          imgUrl: logo3,
        },
        {
          id: "wm-logo-4",
          title: "WrestleMania IV",
          description: "What the World is Watching 1988",
          imgUrl: logo4,
        },
        {
          id: "wm-logo-5",
          title: "WrestleMania V",
          description: "The Mega Powers Explode 1989",
          imgUrl: logo5,
        },
        {
          id: "wm-logo-6",
          title: "WrestleMania VI",
          description: "The Ultimate Challenge 1990",
          imgUrl: logo6,
        },
        {
          id: "wm-logo-7",
          title: "WrestleMania VII",
          description: "Superstars and Stripes Forever 1991",
          imgUrl: logo7,
        },
        {
          id: "wm-logo-8",
          title: "WrestleMania VIII",
          description: "Friendship Torn Apart! The Macho/Flair Affair! 1992",
          imgUrl: logo8,
        },
        {
          id: "wm-logo-9",
          title: "WrestleMania IX",
          description: "1993",
          imgUrl: logo9,
        },
        {
          id: "wm-logo-10",
          title: "WrestleMania X",
          description: "Ten Years in the Making 1994",
          imgUrl: logo10,
        },
        {
          id: "wm-logo-11",
          title: "WrestleMania XI",
          description: "1995",
          imgUrl: logo11,
        },
        {
          id: "wm-logo-12",
          title: "WrestleMania XII",
          description: "1996",
          imgUrl: logo12,
        },
        {
          id: "wm-logo-13",
          title: "WrestleMania 13",
          description: "Heat! 1997",
          imgUrl: logo13,
        },
        {
          id: "wm-logo-14",
          title: "WrestleMania",
          description: "The greatest PPV attraction of all time! 1998",
          imgUrl: logo14,
        },
        {
          id: "wm-logo-15",
          title: "WrestleMania XV",
          description: "The Ragin' Climax 1999",
          imgUrl: logo15,
        },
        {
          id: "wm-logo-16",
          title: "WrestleMania 2000",
          description: "A McMahon in Every Corner 2000",
          imgUrl: logo16,
        },
        {
          id: "wm-logo-17",
          title: "WrestleMania X-Seven",
          description: "Houston... We have a problem 2001",
          imgUrl: logo17,
        },
        {
          id: "wm-logo-18",
          title: "WrestleMania X-8",
          description: "The One and Only 2002",
          imgUrl: logo18,
        },
        {
          id: "wm-logo-19",
          title: "WrestleMania XIX",
          description: "Dare to Dream 2003",
          imgUrl: logo19,
        },
        {
          id: "wm-logo-20",
          title: "WrestleMania XX",
          description: "Where it all Begins... Again 2004",
          imgUrl: logo20,
        },
        {
          id: "wm-logo-21",
          title: "WrestleMania 21",
          description: "WrestleMania goes Hollywood 2005",
          imgUrl: logo21,
        },
        {
          id: "wm-logo-22",
          title: "WrestleMania 22",
          description: "Big Time! 2006",
          imgUrl: logo22,
        },
        {
          id: "wm-logo-23",
          title: "WrestleMania 23",
          description: "All Grown Up 2007",
          imgUrl: logo23,
        },
        {
          id: "wm-logo-24",
          title: "WrestleMania XXIV",
          description: "The Biggest WrestleMania Under the Sun 2008",
          imgUrl: logo24,
        },
        {
          id: "wm-logo-25",
          title: "WrestleMania 25",
          description: "The 25th Anniversary of WrestleMania 2009",
          imgUrl: logo25,
        },
        {
          id: "wm-logo-26",
          title: "WrestleMania XXVI",
          description: "Get All Fired Up 2010",
          imgUrl: logo26,
        },
        {
          id: "wm-logo-27",
          title: "WrestleMania XXVII",
          description: "The Biggest WrestleMania Ever 2011",
          imgUrl: logo27,
        },
        {
          id: "wm-logo-28",
          title: "WrestleMania XXVIII",
          description: "Once in a Lifetime 2012",
          imgUrl: logo28,
        },
        {
          id: "wm-logo-29",
          title: "WrestleMania NY|NJ",
          description: "WrestleMania is Coming Home 2013",
          imgUrl: logo29,
        },
        {
          id: "wm-logo-30",
          title: "WrestleMania XXX",
          description: "Laissez les Bons Temps Rouler 2014",
          imgUrl: logo30,
        },
        {
          id: "wm-logo-31",
          title: "WrestleMania",
          description: "2015",
          imgUrl: logo31,
        },
        {
          id: "wm-logo-32",
          title: "WrestleMania",
          description: "2016",
          imgUrl: logo32,
        },
        {
          id: "wm-logo-33",
          title: "WrestleMania",
          description: "The Ultimate Thrill Ride 2017",
          imgUrl: logo33,
        },
        {
          id: "wm-logo-34",
          title: "WrestleMania",
          description: "2018",
          imgUrl: logo34,
        },
        {
          id: "wm-logo-35",
          title: "WrestleMania",
          description: "WrestleMania comes to New York City 2019",
          imgUrl: logo35,
        },
        {
          id: "wm-logo-36",
          title: "WrestleMania",
          description: "Too Big for Just One Night! 2020",
          imgUrl: logo36,
        },
        {
          id: "wm-logo-37",
          title: "WrestleMania",
          description: "Too Big for Just One Night!... Again! 2021",
          imgUrl: logo37,
        },
        {
          id: "wm-logo-38",
          title: "WrestleMania",
          description: "The Most Stupendous Two-Night Event In WrestleMania History 2022",
          imgUrl: logo38,
        },
        {
          id: "wm-logo-39",
          title: "WrestleMania Hollywood",
          description: "WrestleMania Goes Hollywood 2023",
          imgUrl: logo39,
        },
        {
          id: "wm-logo-40",
          title: "WrestleMania XL",
          description: "2024",
          imgUrl: logo40,
        },
        {
          id: "wm-logo-41",
          title: "WrestleMania 41",
          description: "2025",
          imgUrl: logo41,
        },
        {
          id: "wm-logo-42",
          title: "WrestleMania Vegas",
          description: "2026",
          imgUrl: logo42,
        },
      ],
    },
  ],
};
